/**
 * Branches and sections the signed-in user may operate.
 *
 * The server returns them already filtered by role assignment, so this needs no
 * client-side scoping — and must not add any. Filtering here would be exactly
 * the "rely only on frontend filtering" the brief forbids.
 */

import { api } from "@/api/client";

export interface SectionOption {
  sectionId: string;
  sectionName: string;
  branchId: string;
  branchName: string;
  isDefault: boolean;
}

interface SectionResponse {
  id: string;
  name: string;
  branch: string;
  branch_name: string;
  is_default: boolean;
}

export const hierarchyRepository = {
  async sectionsForUser(): Promise<SectionOption[]> {
    try {
      const rows = await api.get<SectionResponse[]>("/sections/mine/");
      return rows.map((row) => ({
        sectionId: row.id,
        sectionName: row.name,
        branchId: row.branch,
        branchName: row.branch_name,
        isDefault: row.is_default,
      }));
    } catch {
      // Offline, or the endpoint is unreachable. An empty list hides the selector
      // rather than showing a broken control — Phase 5 serves this from the local
      // replica instead.
      return [];
    }
  },
};
